// src/hooks/useUserProfile.js
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const useUserProfile = (uid) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!uid) {
        console.log("[useUserProfile] No uid provided, skipping fetch");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        console.log("[useUserProfile] Fetching profile for uid:", uid);
        const userDocRef = doc(db, "users", uid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          console.log("[useUserProfile] Snapshot data:", data);
          setProfileData(data);
        } else {
          console.warn("[useUserProfile] User profile not found for uid:", uid);
          setError("User profile not found");
        }
      } catch (err) {
        console.error("[useUserProfile] Failed to fetch user profile:", err);
        setError("Failed to fetch user profile");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [uid]);

  return { profileData, loading, error };
};

export default useUserProfile;